import {BaseModel} from "../_base/crud";

export class ConfigLogistic extends BaseModel {
    id: number;
    campaignId: number;
    campaignNumber: string;
    levelIds: [];
    quantityItmsNotCategorized: number;
}
